export default [
  {
    key: 'firstName',
    label: 'field.firstName',
    rules: 'required',
    type: 'text',
  },
  {
    key: 'lastName',
    label: 'field.lastName',
    rules: 'required',
    type: 'text',
  },
  {
    key: 'roles',
    label: 'field.role',
    rules: 'required',
    type: 'nAsynMultiSelection',
    repository: 'role',
    selectionKey: 'id',
    selectionLabel: 'name',
  },
  {
    label: 'breadcrumb.accountInfomration',
    icon: 'LockIcon',
    type: 'divider',
  },
  {
    key: 'email',
    label: 'field.email',
    rules: 'required|email',
    type: 'text',
    cols: 12,
  },
  {
    key: 'password',
    name: 'new-password',
    label: 'field.password',
    rules: 'required|min:6',
    type: 'password',
    hideInView: true,
  },
  {
    key: 'retypePassword',
    label: 'field.retypePassword',
    rules: 'required|confirmed:password',
    type: 'password',
    hideInView: true,
  },
  {
    key: 'isEnable',
    label: 'status.active',
    rules: '',
    type: 'checkbox',
    cols: 'auto',
  },
]
